import React, { useRef, useEffect } from 'react'

import { Location } from '../types'
import useGoogleMaps from '../hooks/useGoogleMaps'

interface ProductMapProps {
	locations: Location[]
}

const ProductMap: React.FC<ProductMapProps> = props => {
	const ready = useGoogleMaps('AIzaSyApUZs_DVCx6jK7c6CUrIIrSU8KKyKjGZo')
	const ref = useRef(null)

	useEffect(() => {
		if (ref.current !== null && ready && props.locations.length > 0) {
			const bound = new google.maps.LatLngBounds()

			const positions = props.locations.map(location => {
				const position = new google.maps.LatLng(
					parseFloat(location.latitude),
					parseFloat(location.longitude),
				)

				bound.extend(position)

				return position
			})

			console.log(positions.length > 0 ? bound.getCenter() : positions[0])

			const map = new google.maps.Map(ref.current!, {
				disableDefaultUI: true,
				zoomControl: false,
				scrollwheel: false,
				disableDoubleClickZoom: true,
				center: positions.length > 0 ? bound.getCenter() : positions[0],
				zoom: 10
			})

			if (positions.length > 1) {
				map.fitBounds(bound)
			}

			let infowindows: any[] = []

			props.locations.map(location => {
				const position = new google.maps.LatLng(
					parseFloat(location.latitude),
					parseFloat(location.longitude),
				)

				const marker = new google.maps.Marker({
					position,
					map: map,
					title: location.name,
				})

				const infowindow = new google.maps.InfoWindow({
					content: `${location.name}  `,
				})

				infowindows.push(infowindow)

				marker.addListener('click', () => {
					infowindows.forEach(window => window.close())
					infowindow.open(map, marker)
				})

				marker.setMap(map)

				return marker
			})

			if (positions.length > 1) {
				new google.maps.Polyline({
					path: positions,
					geodesic: true,
					strokeColor: '#45545e',
					strokeOpacity: 1.0,
					strokeWeight: 2.0,
				}).setMap(map)
			}
		}
	}, [ready, props.locations])

	if (props.locations.length === 0) {
		return null
	}

	return (
		<div
			className="grid__col--10 grid__col--offset-1 grid__col--spacing"
			ref={ref}
			style={{ height: '400px', border: '1px solid #bfbfbf' }}
		/>
	)
}
export default ProductMap
